import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MatLegacyRadioChange as MatRadioChange } from '@angular/material/legacy-radio';
import { Subject, debounceTime, distinctUntilChanged, finalize } from 'rxjs';
import { ExdrLanguageService } from 'src/app/languages/services/exdr-language.service';
import { TopicType, TopicTypeService } from 'src/app/products/products-type-setting/topic-type.service';

@Component({
  selector: 'xcdrs-topictype-search-dialog',
  templateUrl: './topictype-search-dialog.component.html',
  styleUrls: ['./topictype-search-dialog.component.scss']
})
export class TopictypeSearchDialogComponent implements OnInit {

  loading: boolean;
  // Setting default language to english
  language:string = "en";
  // Topic type has only name & id
  selectedItem: { id: string, name: string, slug: string};
  searchedItems: { id: string, name: string, slug: string }[] = []
  private searchDecouncer$: Subject<string> = new Subject();
  title:string;
  topicTypesArray: Array<TopicType> = [];

  constructor(
    private topicTypeService:TopicTypeService,
    private langService: ExdrLanguageService,
    private dialogRef: MatDialogRef<TopictypeSearchDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      accessList: string,
      selectedItemId: string,
      isRelatedTopicCall: boolean,
    }
  ) { 
    this.title = 'CustomTabsPage.SelectTopic';
  }

  ngOnInit(): void {
    this.fetchTopicTypes();
    this.setupSearchDebouncer();
    this.setLanguage();
  }

  setLanguage():void{
    if(this.langService.currentLanguage.isRtl){
      this.language="ar";
    }
  }

  // Search Functionality

  onSearchInputChange(event: any) {
    this.searchDecouncer$.next(event)
  }

  private setupSearchDebouncer(): void {
    this.searchDecouncer$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
    ).subscribe((term: string) => {
      this.search(term);
    });
  }

  private search(searchTerm: string): void {
    this.searchedItems = this.topicTypesArray
      .filter(item => item.TopicTypeName.toLowerCase().includes(searchTerm.toLowerCase()))
      .map(tt => {
        let name;
        try {
          const nameObj = JSON.parse(tt.TopicTypeName);
          name = nameObj.en || nameObj.ar || tt.TopicTypeName; 
        } catch (error) {
          name = tt.TopicTypeName;
        }
        return {
          id: tt.TopicTypeId,
          name: name,
          slug: this.convertToSlug(name)
        };
      });
  }
  
  // API to fetch topictypes
  fetchTopicTypes() {
    this.loading = true;
    this.topicTypeService.getTopicTypes(this.data.accessList?.toString()).pipe(
      finalize(() => this.loading = false)
    ).subscribe(tts => {
      this.topicTypesArray = tts.filter(tt => tt.TopicTypeName !== 'HTMLPage');
      this.searchedItems = this.topicTypesArray.map(tt => {
        let name;
        try {
          // Attempt to parse the TopicTypeName as JSON
          const nameObj = JSON.parse(tt.TopicTypeName);
          name = nameObj.en || nameObj.ar || tt.TopicTypeName; // Fallback to Arabic if English is not available
        } catch (error) {
          // If parsing fails, use TopicTypeName as a simple string
          name = tt.TopicTypeName;
        }
        return {
          id: tt.TopicTypeId,
          name: name,
          slug:name
        };
      });
    });
  }

  private convertToSlug(text: string): string {
    return text.toLowerCase()
      .replace(/ /g, '-')   // Replace spaces with -
      .replace(/[^\w-]+/g, ''); // Remove all non-word chars
  }
  
  closeDialog() {
    this.dialogRef.close(this.selectedItem);
  }

  isSelected(itemId): boolean {
    if (this.selectedItem && !this.data.selectedItemId) {
      return this.selectedItem.id == itemId;
    } else if (this.data?.selectedItemId && this.data?.selectedItemId == itemId) {
      return true;
    }
    return false;
  }

  onRadioBtnChange(event: MatRadioChange) {
    const itemId = event.source.value;
    const item = this.searchedItems.find(i => i.id == itemId);
    if (item) {
      this.selectedItem = {
        ...item,
        slug: this.convertToSlug(item.name) 
      };
    }
  }
  

}
